import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_GATEWAY,
  headers: { "x-api-key": "81a024e7-51c0-490e-aa72-b1d17382d048" },
});

export default axiosInstance;
